export default {"src":"/login-app/[GIT_HASH]/_next/static/media/settings.733d2b3e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};